import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@omilia/providers';

interface Props extends React.SVGAttributes<SVGElement> {
  color?: string;
  disabled: boolean;
  handleClick(event: React.FormEvent): void;
}

const SButton = styled.button<{ disabled: boolean; $bgColor: string }>`
  align-items: center;
  background: ${({ $bgColor }) => $bgColor};
  border: none;
  border-radius: 40px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  padding: 8px;
`;

const IconSend = ({ color, disabled, handleClick }: Props) => {
  const { t } = useTranslation();

  return (
    <SButton
      type="submit"
      disabled={disabled}
      $bgColor={color || '#FFFFFF'}
      onClick={handleClick}
      aria-label={t('footer.sendMessage')}
      tabIndex={disabled ? -1 : 0}
    >
      <svg width="20px" height="20px" viewBox="0 0 24 24">
        <title>{t('footer.sendMessage')}</title>
        <defs>
          <path
            d="M21.459566,12.8738986 L3.41431516,21.8966121 C2.93156625,22.1379889 2.34454826,21.9423143 2.1031738,21.4595607 C2.01151988,21.2762511 1.97981452,21.0687655 2.01254185,20.8664491 L2.95287596,15.0534179 C3.01317733,14.6806422 3.28284555,14.3759651 3.64553486,14.2708368 L8.89509497,12.7492103 C9.30980875,12.6290022 9.54855375,12.1953591 9.42834686,11.7806413 C9.3538217,11.523527 9.15292968,11.3224181 8.89589773,11.2476173 L3.6445263,9.71937722 C3.28237504,9.61398492 3.01319959,9.30959378 2.95289985,8.93726664 L2.01296133,3.13351688 C1.92667359,2.60072413 2.28863321,2.09885955 2.82142076,2.01257097 C3.02379029,1.97979584 3.23134237,2.01149228 3.41470565,2.10317481 L21.459566,11.1256931 C21.9423149,11.3670699 22.1379876,11.9540936 21.8966131,12.4368472 C21.8020491,12.625977 21.6486939,12.7793337 21.459566,12.8738986 Z"
            id="path-1"
          />
        </defs>
        <g
          id="STYLE"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Styleguide-/-Icons-Collection"
            transform="translate(-1304.000000, -3815.000000)"
          >
            <g id="Group-9" transform="translate(230.000000, 1439.000000)">
              <g
                id="icons/send"
                transform="translate(1074.000000, 2376.000000)"
              >
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1" />
                </mask>
                <use id="Triangle" fill="#FFFFFF" xlinkHref="#path-1" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SButton>
  );
};

IconSend.defaultProps = {
  color: '#FFFFFF',
};

export default IconSend;
